import styled from 'styled-components';
import { Label } from './Label.styles';
import { ImageWrapper } from './ImageWrapper.styles';
import { TransparentLayer } from '../expressive/common/Common.styles';
export const ProductiveTileContainer = styled.div `
  position: relative;
  flex: 1 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid transparent;
  outline: 1px solid transparent;
  background-color: transparent;
  box-sizing: border-box;

  > div.aspect-ratio-wrapper {
    /* background-color */
    ${({ type, theme }) => {
    if (type === 'tlpa3-a') {
        return `background-color: ${theme.colors.white};`;
    }
    if (type === 'tlpa3-b') {
        return `background-color: ${theme.colors.grey03};`;
    }
    return '';
}}

    ${({ type }) => (type.includes('tlpa3') ? `min-height: 6rem;padding: 0.5rem;` : '')}
  }

  /* padding */
  ${({ type }) => {
    if (type.includes('tlpa1')) {
        return 'padding: 0.5rem;';
    }
    return '';
}}

  /* background-color */
    ${({ type, theme }) => {
    if (type === 'tlpa2') {
        return `background-color: ${theme.colors.white};`;
    }
    return '';
}};

  /* border */
  ${({ type, theme, selected }) => {
    if (selected) {
        return `border-color: ${theme.colors.black};`;
    }
    if (type === 'tlpa2' || type.includes('tlpa3')) {
        return `border-color: rgba(${theme.colors.transparentBlack}, 0.2);`;
    }
    return '';
}}

  & ${TransparentLayer} {
    /* background-color */
    ${({ type, selected }) => {
    if (type === 'tlpa2' && selected) {
        return `background-color: rgba(255,255,255, 0);`;
    }
    return '';
}}
  }

  :hover {
    cursor: pointer;
    .image-container div {
      ${({ scaleOnHover }) => (scaleOnHover ? `transform: scale(1.07);` : '')}
    }

    /* border */
    ${({ type, theme, selected }) => {
    if (selected) {
        return '';
    }
    if (type === 'tlpa2' || type.includes('tlpa3')) {
        return `border-color: rgba(${theme.colors.transparentBlack}, 0.36);`;
    }
    return '';
}}

    & ${ImageWrapper},  > div.aspect-ratio-wrapper {
      /* background-color */
      ${({ type, theme }) => {
    if (type === 'tlpa3-b') {
        return `background-color: ${theme.colors.grey05};`;
    }
    return '';
}}

      & ${TransparentLayer} {
        /* background-color */
        ${({ type }) => {
    if (type === 'tlpa2') {
        return `background-color: rgba(255,255,255, 0);`;
    }
    return 'display: none;';
}}
      }
    }

    & ${Label} {
      /* background-color */
      ${({ type, theme }) => {
    if (type.includes('tlpa3-a')) {
        return `background-color: ${theme.colors.grey05};`;
    }
    return '';
}};
    }
  }

  :focus {
    /* border */
    ${({ theme, focused }) => {
    if (!focused)
        return '';
    return `border-color: ${theme.colors.primaryLight};`;
}}

    /* outline */
    ${({ theme, focused }) => {
    if (!focused)
        return '';
    return `outline-color: ${theme.colors.primaryLight};`;
}}
  }

  :active {
    /* background-color */
    ${({ type, theme }) => {
    if (type.includes('tlpa1')) {
        return `background-color: rgba(${theme.colors.transparentBlack}, 0.06);`;
    }
    return '';
}};

    ${({ theme }) => {
    return `border-color: ${theme.colors.black};`;
}};

    & ${Label} {
      /* background-color */
      ${({ type, theme }) => {
    if (type.includes('tlpa3-a')) {
        return `background-color: ${theme.colors.grey06};`;
    }
    return '';
}};
    }
    & ${ImageWrapper}, > div.aspect-ratio-wrapper {
      /* background-color */
      ${({ type, theme }) => {
    if (type === 'tlpa3-b') {
        return `background-color: ${theme.colors.grey06};`;
    }
    return '';
}}
      & ${TransparentLayer} {
        /* background-color */
        ${({ type }) => {
    if (type === 'tlpa2') {
        return `background-color: rgba(255,255,255, 0.06);`;
    }
    return '';
}}
      }
    }
  }

  @media ${({ theme }) => theme.device.medium} {
    flex: 1;
  }
`;
export const ImageContainer = styled.div `
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-bottom: 1px solid transparent;
`;
